import React, { useEffect, useState } from "react";
import Pagination from "./Pagination";
import { APPLY_FOR_JOB } from "../utils/constants";
import { makeAuthenticatedGet } from "../utils/fetchUtils";
import { Navigate, useNavigate } from "react-router-dom";
import google from "../assets/google.svg";
import govt from '../assets/Emblem_of_India.svg.png';
import briefcase from '../assets/briefcase.png';
import ReactMarkdown from "react-markdown";

import location from "../assets/location.svg"


export const Card = (props: any) => {
  const navigate = useNavigate();

  const [jobDisplay, setJobDisplay] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);

  function toggleJob(): void {
    setJobDisplay((prev) => !prev);
    props.job.markAsRead = true;
  }

  async function applyForJob() {
    try {
      const url = APPLY_FOR_JOB.replace("{jobId}", props.job._id);
      const response = await makeAuthenticatedGet(url);
      const temp = response;
      console.log("application", temp);
      navigate("/appliedjob");
    } catch (error: any) {
      console.error("Error fetching jobs: ", error);
    }
  }

  useEffect(() => {
    console.log("mark as read changed for job");
  }, [props.job.markAsRead]);

  const detailsId = `job-details-${String(props.job._id || props.index).replace(/[^a-zA-Z0-9_-]/g, "-")}`;

  return (
      <article className="opportunity-card unopened" aria-labelledby={`${detailsId}-title`}>
        <div
          className={
            props.job.markAsRead
              ? "d-flex justify-content-between  card-body"
              : "d-flex justify-content-between  card-body unread"
          }
        >
          <div className="d-flex flex-wrap items-start" style={{ gap: "1rem", width: "100%" }}>
              <img
                src={props.job.logo_url || briefcase}
                alt={props.job.logo_url ? `${props.job.company || "Company"} logo` : ""}
              className={jobDisplay ? "company-logo small-logo" : "company-logo"}
              style={{ maxWidth: "80px", maxHeight: "80px", objectFit: "contain" }}
            />
            <div className="job-details">
              <h2
                id={`${detailsId}-title`}
                className="card-title col-lg-8 col-sm-12 m-0 p-0"
                style={{ fontWeight: "600" }}
              >
                {props.job.title}
              </h2>
              <h3
                className="company-name col-lg-6 col-sm-12 mt-1 mb-2 font-medium"
              >
                {props.job.company}
              </h3>
              <p className="d-flex" style={{ margin: 0 }}>
                <img src={location} alt="" aria-hidden="true" style={{ width: 20, height: 20, marginRight: 5 }} />
                <span className="visually-hidden">Location: </span>{props.job.address || "Location not provided"}
              </p>
              <button
                type="button"
                className="job-details-toggle"
                onClick={toggleJob}
                aria-expanded={jobDisplay}
                aria-controls={detailsId}
              >
                {jobDisplay ? "Hide job details" : "Show job details"}
                <span aria-hidden="true">{jobDisplay ? "−" : "+"}</span>
              </button>
              <div className="job-expanded-details" id={detailsId} hidden={!jobDisplay}>
                <div>
                  {props.job.jobDetailLink && (
                    <p>
                      <a href={props.job.jobDetailLink} target="_blank" rel="noreferrer">
                        View original job posting
                        <span className="visually-hidden"> (opens in a new tab)</span>
                      </a>
                    </p>
                  )}
                  {props.job.job_nature && (
                    <p>
                      <strong>Job nature:</strong> {props.job.job_nature}
                    </p>
                  )}
                  {props.job.work_experience && (
                    <p>
                      <strong>Work Experience:</strong> {props.job.work_experience}
                    </p>
                  )}
                  {props.job.required_education && (
                    <p>
                      <strong>Required Education:</strong> {props.job.required_education}
                    </p>
                  )}
                  {props.job.resposibilites && (
                    <>
                      <h3>
                        <strong>Responsibilities:</strong>
                      </h3>
                      <ul>
                        <li>{props.job.resposibilites}</li>
                      </ul>
                    </>
                  )}
                  {props.job.minQualification && (
                    <>
                      <h3>
                        <strong>Minimum Qualification:</strong>
                      </h3>
                      <ul>
                        <li>{props.job.minQualification}</li>
                      </ul>
                    </>
                  )}
                  {props.job.prefQualification && (
                    <>
                      <h3>
                        <strong>Preferred Qualification:</strong>
                      </h3>
                      <ul>
                        <li>{props.job.prefQualification}</li>
                      </ul>
                    </>
                  )}
                  {props.job.aboutJob && (
                    <>
                      <h3>
                        <strong>About Job</strong>
                      </h3>
                      <ul>
                        <li>
                          <ReactMarkdown>{props.job.aboutJob}</ReactMarkdown>
                        </li>
                      </ul>
                    </>
                  )}
                  {props.job.pwd_details && (
                    <>
                      <h3>
                        <strong>PWD Details</strong>
                      </h3>
                      <ul>
                        <li>{props.job.pwd_details}</li>
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
  );
};

const OpportunityList = (props: any) => {
  // const [page, setPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);

  // const onPageChange = (newPage: any) => {
  //   if (newPage < 1 || newPage > props.totalPages) return; // Prevent going out of bounds
  //   props.setPage(newPage);
  // };

  return (
    <>
      {props.jobs?.length ? (
        <>
          <ul className="card-container job-results-list" aria-label="Job search results">
            {props.jobs.map((job: any, index: any) => (
              <li key={job._id || index}>
                <Card job={job} index={index} selectedCategory={props.selectedCategory} />
              </li>
            ))}
          </ul>
          <nav className="pagination-container" aria-label="Job results pages">
            <Pagination
              pageNumber={props.page}
              totalPages={props.totalPages}
              onPageChange={props.onPageChange}
            />
          </nav>
        </>
      ) : (
        <div className="empty-results" role="status">
          <h2>No jobs found</h2>
          <p>Try a broader company, title, responsibility, or location search.</p>
        </div>
      )}
    </>
  );
};

export default OpportunityList;
